import HealthAndSafetyRoundedIcon from '@mui/icons-material/HealthAndSafetyRounded';
import RadarRoundedIcon from '@mui/icons-material/RadarRounded';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import type { SvgIconComponent } from '@mui/icons-material';

export const TAB_IDS = ['runs-health', 'content-radar', 'meta-ads'] as const;

export type TabId = (typeof TAB_IDS)[number];

export interface TabMeta {
  id: TabId;
  label: string;
  description: string;
  icon: SvgIconComponent;
  /** Tabs visible only to users explicitly granted to them; admins see all. */
  restricted?: boolean;
}

export const TABS: TabMeta[] = [
  { id: 'runs-health', label: 'Runs & Health', description: 'Pipeline run history and errors', icon: HealthAndSafetyRoundedIcon, restricted: true },
  { id: 'content-radar', label: 'Content Radar', description: 'AI content-intelligence reports from social profiles', icon: RadarRoundedIcon, restricted: true },
  { id: 'meta-ads', label: 'Meta Ads', description: 'Creative performance for Meta paid campaigns', icon: CampaignRoundedIcon, restricted: true },
];

export const TABS_BY_ID: Record<TabId, TabMeta> = Object.fromEntries(TABS.map((t) => [t.id, t])) as Record<TabId, TabMeta>;

export function isTabId(value: unknown): value is TabId {
  return typeof value === 'string' && (TAB_IDS as readonly string[]).includes(value);
}
